// Import necessary dependencies from React
import React, { useEffect, useState } from 'react';

// Import styling for the Search component
import './Search.css';

/**
 * Search component represents an input field for searching coins.
 * @param {string} searchText - Current value of the search input.
 * @param {function} handleSearchBar - Function to handle changes in the search input.
 * @returns {JSX.Element} - Search component.
 */
const Search = ({searchText, handleSearchBar}) => {
  return (
    // Input element for searching coins
    <input
      className="inp90"          // CSS class for styling
      type="text"                // Input type is text
      onChange={handleSearchBar} // Callback function for handling changes in the search input
      value={searchText}         // Current value of the search input
      placeholder="Search coins" // Placeholder text displayed in the input
    />
  );
}

// Export the Search component as the default export of the module
export default Search;
